import React from 'react';
import cn from 'classnames';
import { PORTFOLIO_MONITOR_PAGE_TITLE } from '@/finsight/ui/components/portfolioMonitor/constants';
import PageHeaderWrapper from '@/finsight/ui/common/components/PageHeaderWrapper';
import { UserPlanType } from '@/users/domain/UserPlan';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import MissingSomethingModalButton from '@/finsight/ui/common/components/MissingSomethingModalButton';
import PortfolioMonitor from '@/finsight/ui/components/portfolioMonitor/PortfolioMonitor';
import getPortfolioMonitorOverlay from '@/finsight/ui/components/portfolioMonitor/getPortfolioMonitorOverlay';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const PortfolioMonitorPage = (props) => {
  return (
    <div>
      <PageHeaderWrapper
        title={ PORTFOLIO_MONITOR_PAGE_TITLE }
        requiredUserPlan={ UserPlanType.PRO }
      />
      <CheckUserPlanAccess
        requiredUserPlan={ UserPlanType.PRO }
        fallback={ getPortfolioMonitorOverlay(false) }
      >
        <PortfolioMonitor { ...props } />
      </CheckUserPlanAccess>
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
    </div>
  );
};

export default PortfolioMonitorPage;
